import { TRESPONSE_TNA_BOARD_ORDER_PROGRESS } from '@monorepo/types';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { defaultConfig } from '../../../util';

const tooltipFunction = (data: TRESPONSE_TNA_BOARD_ORDER_PROGRESS['deptWiseOrderProgressDetails'][number]) => {
  return `<div>Order Qty: ${data.orderQty} <br>Shippable Qty: ${data.shippableQty} <br>Produced Qty: ${data.producedQty}  </div>`;
};

const getYAxisMax = (
  graphData:
    | TRESPONSE_TNA_BOARD_ORDER_PROGRESS['deptWiseOrderProgressDetails']
    | TRESPONSE_TNA_BOARD_ORDER_PROGRESS['colorWiseOrderProgressDetails'],
): number => {
  return (
    1.2 *
    Math.max(
      ...graphData.map((x) => x.shippableQty),
      ...graphData.map((x) => x.orderQty),
      ...graphData.map((x) => x.producedQty),
    )
  );
};

const createDepartmentOptions = <T = unknown>(
  graphData: TRESPONSE_TNA_BOARD_ORDER_PROGRESS['deptWiseOrderProgressDetails'],
  pointFormatterHTML: (data: T) => string,
): Highcharts.Options => {
  const columnRangeWidth = Math.max(1, 0.01 * getYAxisMax(graphData));
  const chartConfig: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: graphData.map((x) => x.department),
      title: {
        text: 'Departments',
      },
    },
    yAxis: {
      title: {
        text: 'Quantity',
      },
    },
    tooltip: {
      shared: true,
      pointFormatter: function () {
        const data = this.options.custom as T;
        if (data) {
          return pointFormatterHTML(data);
        }
        return '<div></div>';
      },
    },
    series: [
      {
        name: 'Produced qty',
        data: graphData.map((data, index) => {
          return {
            x: index,
            y: data.producedQty,
            custom: data,
          };
        }),
        type: 'column',
        color: '#007D35',
      },
      {
        name: 'Order  Quantity',
        type: 'columnrange',

        color: '#0F31A9',
        data: graphData.map((x) => [x.orderQty, x.orderQty + columnRangeWidth]),
      },

      {
        name: 'Shippable Quantity',
        type: 'columnrange',

        color: '#00B2BD',
        data: graphData.map((x) => [x.shippableQty, x.shippableQty + columnRangeWidth]),
      },
    ],
  };
  return chartConfig;
};

const createColorOptions = <T = unknown>(
  graphData: TRESPONSE_TNA_BOARD_ORDER_PROGRESS['colorWiseOrderProgressDetails'],
  pointFormatterHTML: (data: T) => string,
): Highcharts.Options => {
  const columnRangeWidth = Math.max(1, 0.01 * getYAxisMax(graphData));
  const chartConfig: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: graphData.map((x) => x.color),
      title: {
        text: 'Colors',
      },
    },
    yAxis: {
      title: {
        text: 'Quantity',
      },
      min: 0,
    },
    tooltip: {
      shared: true,
      pointFormatter: function () {
        const data = this.options.custom as T;
        if (data) {
          return pointFormatterHTML(data);
        }
        return '<div></div>';
      },
    },
    series: [
      {
        name: 'Produced qty',
        data: graphData.map((data, index) => {
          return {
            x: index,
            y: data.producedQty,
            custom: data,
          };
        }),
        type: 'column',
        color: '#007D35',
      },
      {
        name: 'Order  Quantity',
        type: 'columnrange',

        color: '#0F31A9',
        data: graphData.map((x) => [x.orderQty, x.orderQty + columnRangeWidth]),
      },

      {
        name: 'Shippable Quantity',
        type: 'columnrange',

        color: '#00B2BD',
        data: graphData.map((x) => [x.shippableQty, x.shippableQty + columnRangeWidth]),
      },
    ],
  };
  return chartConfig;
};

export const ORDER_PROGRESS_CHART_MODEL = {
  createDepartmentModel: (departmentData: TRESPONSE_TNA_BOARD_ORDER_PROGRESS['deptWiseOrderProgressDetails']) => {
    const defaultConfigCopy = _.cloneDeep(defaultConfig);
    return _.merge(defaultConfigCopy, createDepartmentOptions(departmentData, tooltipFunction));
  },
  createColorModel: (colorData: TRESPONSE_TNA_BOARD_ORDER_PROGRESS['colorWiseOrderProgressDetails']) => {
    const defaultConfigCopy = _.cloneDeep(defaultConfig);
    return _.merge(defaultConfigCopy, createColorOptions(colorData, tooltipFunction), defaultConfig);
  },
};
